import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { DisplayBoard } from '@/components/DisplayBoard';

export function DisplayPage() {
  const { businessId } = useParams<{ businessId: string }>();

  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'F11') {
        e.preventDefault();
        if (!document.fullscreenElement) {
          document.documentElement.requestFullscreen().catch(() => {});
        } else {
          document.exitFullscreen().catch(() => {});
        }
      }
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, []);

  useEffect(() => {
    // Auto request fullscreen on load for TV displays (after user interaction hint)
    const hint = document.getElementById('fullscreen-hint');
    if (hint) {
      const t = setTimeout(() => hint.classList.add('opacity-0'), 4000);
      return () => clearTimeout(t);
    }
  }, []);

  if (!businessId) {
    return (
      <div className="flex items-center justify-center min-h-screen" style={{ background: 'var(--qr-bg)', color: 'var(--qr-text)' }}>
        <p>ID de negocio no proporcionado</p>
      </div>
    );
  }

  return (
    <>
      <div
        id="fullscreen-hint"
        className="fixed top-4 right-4 z-50 px-3 py-1.5 rounded-lg text-xs font-medium transition-opacity duration-700"
        style={{ background: 'var(--qr-surface)', border: '1px solid var(--qr-border)', color: 'var(--qr-text-secondary)' }}
      >
        Presiona F11 para pantalla completa
      </div>
      <DisplayBoard businessId={businessId} />
    </>
  );
}
